export default __webpack_public_path__ + "static/media/t_3.8062a93b.jpg";